import {isPlatformBrowser} from '@angular/common';
import {Inject, PLATFORM_ID} from '@angular/core';
import {ActionTypeStrategy, TransactionListCta} from '@dcp/configurator';

export class NewPageActionTypeStrategy implements ActionTypeStrategy {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private cta: TransactionListCta,
  ) {
  }

  public action(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cta?.targetUrl) {
        try {
          const url = new URL(this.cta.targetUrl);
          url.searchParams.set('back', '1');
          window.open(url.href, '_blank');
        } catch (e) {
          throw new Error(e.message);
        }
      } else {
        throw new Error('Target url is missing');
      }
    }
  }
}
